<template>
  <v-parallax height="100%" :src="require('@/assets/temasek-bg.jpg')">
    <v-app>
      <div class="temasek-header">
        <v-img :src="require('@/assets/temasek-logo.png')" contain aspect-ratio="1" height="140px" />
      </div>
      <v-content>
        <v-container class="temasek-content">
          <router-view />
        </v-container>
      </v-content>
    </v-app>
  </v-parallax>
</template>

<script>
export default {
  name: "App",
  components: {},
  watch: {
      $route: {
          immediate: true,
          handler(to) {
              document.title = to.meta.title || "Smiley Tool Kiosk - Temasek Club";
          }
      }
  },
  data: () => ({
    //
  })
};
</script>

<style>
.temasek-header {
  position: relative;
  height: 20vh;
  padding: 28px;
}
.temasek-content {
  max-width: 1024px !important;
  height: 80vh;
}
.theme--dark.v-application {
  background: transparent !important;
}
.v-parallax__content{
    box-shadow: 0 0 20px inset rgba(0, 0, 0, 0.2);
    background-image: linear-gradient(to bottom, rgba(0, 0, 0, 0.8) 5%,  rgba(0, 0, 0, 0.4) 100%) !important;
}
</style>